import { render } from "./Orders.vue?vue&type=template&id=d5798292&scoped=true&ts=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=d5798292&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5798292"]])

export default __exports__